import {createProgram} from "../primitiveHelpers.js";
import {primitiveFragShader, primitiveVertShader} from "../shaders/primitiveShader.js";
import mapboxgl from "mapbox-gl";
import * as THREE from "three";
import { getScalingFactor } from "../helpers.js";
import Stats from "three/addons/libs/stats.module.js";


let program;
let vbo;
let pos = [];
let plateCreated = false;
let statsPanels;

const anchor = [0, 0];
const plateSize = 1_000_000;
const earthRadius = 1303.797293808806;

let plate;

//
// const earthsNipple = [];
// const numPoints = 10000;
// const numRotations = 100;
// const scale = 50;
// const angleIncrement = (Math.PI * 2 * numRotations) / numPoints;
//
// for (let i = 0; i < numPoints; i++) {
//   const angle = i * angleIncrement;
//   const radius = scale * (i / numPoints);
//
//   const x = radius * Math.cos(angle);
//   const y = radius * Math.sin(angle);
//
//   earthsNipple.push([x, y]);
// }


const xPos = 50;


export const pointPrimitiveLayer = {
  id: 'point-primitive-layer',
  type: 'custom',
  onAdd: (map, gl) => {

    // this.ma

    const stats1 = new Stats();
    stats1.showPanel(0);
    document.body.appendChild(stats1.dom);

    const stats2 = new Stats();
    stats2.showPanel(1);
    stats2.dom.style.left = '80px';
    document.body.appendChild(stats2.dom);

    const stats3 = new Stats();
    stats3.showPanel(2);
    stats3.dom.style.left = '160px';
    document.body.appendChild(stats3.dom);
    statsPanels = [stats1, stats2, stats3];

    vbo = gl.createBuffer();
    program = createProgram(gl, primitiveVertShader, primitiveFragShader);

    plate = new mapboxgl.LngLatBounds(
      [10, xPos],
      [0, xPos + 10]
    );
    const plate1Points = [
      [
        xPos + 5,5
      ]
    ]

    // const plate1Points = [
    //   [
    //     -15,5
    //   ]
    // ]
    // plate = new mapboxgl.LngLatBounds(
    //   [10, -20],
    //   [0, -10]
    // );


    const p1NorthEast = plate.getNorthEast();
    const p1NorthWest = plate.getNorthWest();
    const p1SouthEast = plate.getSouthEast();
    const p1SouthWest = plate.getSouthWest();


    map.on("load", () => {

      map.addLayer({
        id: 'line-bounding-box',
        type: 'line',
        paint: {
          'line-color': '#3386c0',
          'line-width': 3,
          'line-opacity': 0.9
        },
        source: {
          type: 'geojson',
          data: {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'Polygon',
              'coordinates': [
                [
                  [p1NorthWest.lat, p1NorthWest.lng],
                  [p1NorthEast.lat, p1NorthEast.lng],
                  [p1SouthEast.lat, p1SouthEast.lng],
                  [p1SouthWest.lat, p1SouthWest.lng],
                  [p1NorthWest.lat, p1NorthWest.lng],
                ]
              ]
            }
          }
        }
      });
    });



    const altitude = 0;

    for (
      let i = 0;
      i < plate1Points.length;
      i++
    ) {

      const lon = plate1Points[i][0];
      const lat = plate1Points[i][1];

      if (lon && lat) {
        const merc = mapboxgl.MercatorCoordinate.fromLngLat(
          [lon, lat],
          altitude,
        );

        pos.push(merc.x, merc.y, merc.z);
      }
    }

    updateVboAndActivateAttrib(
      gl,
      program,
      vbo,
      pos,
      'position',
    );

  },
  render: (
    gl,
    projectionMatrix,
    projection,
    globeToMercMatrix,
    transition,
    centerInMercator,
    pixelsPerMeterRatio,
  ) => {
    statsPanels.forEach(stats => stats.begin());

    gl.useProgram(program);
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo);


    if (projection && projection.name === 'globe') {
      if (!plateCreated) {

        // const plate = new mapboxgl.LngLat(anchor[0], anchor[1]).toBounds(plateSize);

        const nw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthWest(), 0);
        const sw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthWest(), 0);
        const ne_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthEast(), 0);
        const se_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthEast(), 0);


        setUniform(gl, program, "u_plate_tl_up", new THREE.Vector3().fromArray(plate.getNorthWest().toEcef(0)));
        setUniform(gl, program, "u_plate_br_up", new THREE.Vector3().fromArray(plate.getSouthWest().toEcef(0)));
        setUniform(gl, program, "u_plate_tr_up", new THREE.Vector3().fromArray(plate.getNorthEast().toEcef(0)));
        setUniform(gl, program, "u_plate_bl_up", new THREE.Vector3().fromArray(plate.getSouthEast().toEcef(0)));

        setUniform(gl, program, "u_plate_tl", new THREE.Vector3(nw_merc.x, nw_merc.y, nw_merc.z));
        // setUniform(gl, program, "u_plate_bl", new THREE.Vector3(sw_merc.x, sw_merc.y, sw_merc.z));
        setUniform(gl, program, "u_plate_tr", new THREE.Vector3(ne_merc.x, ne_merc.y, ne_merc.z));
        // setUniform(gl, program, "u_plate_br", new THREE.Vector3(se_merc.x, se_merc.y, se_merc.z));

        setUniform(gl, program, "u_plate_width", nw_merc.x - ne_merc.x)
        setUniform(gl, program, "u_plate_height", sw_merc.y - nw_merc.y)
        setUniform(gl, program, "u_scale_factor", getScalingFactor(anchor[1]))
        setUniform(gl, program, "u_plate_up_scale", earthRadius)

        plateCreated = true;
      }


      activateAttrib(gl, program, 'position');

      setUniform(gl, program, "u_matrix_globe_merc", new THREE.Matrix4().fromArray(globeToMercMatrix));
      setUniform(gl, program, "projectionMatrix", new THREE.Matrix4().fromArray(projectionMatrix));

      setUniform(gl, program, "u_zoom_transition", transition);
      setUniform(gl, program, "u_pixelsPerMeterRatio", pixelsPerMeterRatio);
      setUniform(gl, program, "u_centerInMerc", new THREE.Vector2().fromArray(centerInMercator));

      setUniform(gl, program, "u_point_size", 5.0);

      gl.drawArrays(gl.POINTS, 0, pos.length / 3);
    } else {
      activateAttrib(gl, program, 'position');
      setUniform(gl, program, "u_point_size", 5.0);

      setUniform(gl, program, "projectionMatrix", new THREE.Matrix4().fromArray(projectionMatrix));
      setUniform(gl, program, "u_zoom_transition", 1);
      gl.drawArrays(gl.POINTS, 0, pos.length / 3);
    }
  statsPanels.forEach(stats => stats.end());
  }

}


function activateAttrib(
  gl,
  program,
  attribName,
) {
  const attribLoc = gl.getAttribLocation(program, attribName);
  gl.vertexAttribPointer(attribLoc, 3, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(attribLoc);
}

function setUniform(gl, program, uniformName, value) {
  const location = gl.getUniformLocation(program, uniformName);
  if (!location) {
    console.warn(`Uniform ${uniformName} not found`);
    return;
  }

  if (value instanceof THREE.Matrix4) {
    gl.uniformMatrix4fv(location, false, value.elements);
  } else if (value instanceof THREE.Vector3) {
    gl.uniform3fv(location, value.toArray());
  } else if (value instanceof THREE.Vector2) {
    gl.uniform2fv(location, value.toArray());
  } else if (typeof value === "number") {
    gl.uniform1f(location, value);
  } else {
    console.error(`Incorrect uniform type for ${uniformName}`);
  }
}


function updateVboAndActivateAttrib(
  gl,
  prog,
  vbo,
  data,
  attribName,
) {
  gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data), gl.DYNAMIC_DRAW);
  const attribLoc = gl.getAttribLocation(prog, attribName);
  gl.vertexAttribPointer(attribLoc, 3, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(attribLoc);
}
